
import React, { useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import PageLayout from 'app/src/layout/PageLayout'
import { Table, Skeleton, Button } from 'antd'
import moment from 'moment'

import Fetch from '../../../components/crud/Fetch'
import authClient from '../../../utils/authClient'

const Certificate = () => {
  // let timeout = 0
  const defaultPage = 1
  const defaultPageSize = 10
  const params = useParams()
  const fetchRef = useRef(null)
  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [search, setSearch] = useState('')
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const fetch = async ({ page, pageSize }) => {
    const filter = {
      where: {
        programCertificateId: params.id,
      },
    }
    const data = await authClient.client
    .get('/api/StudentCertificates', {
      params: {
        filter: {
          ...filter,
          order: 'certificatedDate ASC',
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      },
    })
    .then(res => res.data)

  const count = await authClient.client
    .get('/api/StudentCertificates/count', {
      params: {
        where: filter.where,
      },
    })
    .then(res => res.data)
    return {
      data,
      total: count.count,
    }
  }

  const handleChange = (pagination, filters, sorter) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  return (
    <PageLayout
      hideBack
      title="Ceritificate list"
      onClickReload={() => fetchRef.current.reload()}
      onClickSearch={() => fetchRef.current.reload()}
    >
      {search === searchText ? (
        <Fetch fetch={fetch} params={{ page, pageSize}} ref={fetchRef}>
          {({ data, total }) => (
            <Table
              rowKey="id"
              onChange={handleChange}
              columns={columns}
              dataSource={data}
              pagination={{
                defaultCurrent: defaultPageSize,
                defaultPageSize: defaultPageSize,
                current: page,
                pageSize: pageSize,
                total: total,
              }}
              scroll={{ x: 768 }}
            />
          )}
        </Fetch>
      ) : (
          <Skeleton />
        )}
    </PageLayout>
  )
}

export default Certificate

const columns = [
  {
    title: 'No.',
    key: 'no',
    width: 100,
    render: (text, n, index) => <div className="text-tr-main">{index + 1}</div>,
  },
  {
    title: 'Student Name',
    key: 'name',
    width: 200,
    render: row => <div className="text-tr-sub">{row.certificateTemplate.studentName}</div>,
  },
  {
    title: 'Issue Date',
    key: 'issueDate',
    width: 200,
    render: row => <div className="text-tr-sub">{moment(row.certificatedDate).format('DD MMM YYYY')}</div>,
  },
  {
    title: '',
    key: 'operation',
    width: 150,
    render: row =>
      <Button href={`${process.env.REACT_APP_API_URL}/api/StudentCertificates/${row.id}/certificate`} target="_blank" rel="noopener noreferrer">Download</Button>
  },
]
